export { default } from './Logo';



// WEBPACK FOOTER //
// ./src/ui/common/rebranding/components/Logo/index.js